import React from 'react';
import { useSteps } from '@workday/upc-common';
import { SendPhoneOtpStep } from './send-phone-otp-step';
import { VerifyPhoneStep } from './verify-phone-step';
import { Contact } from '../../../slices/auth-api.slice';

interface VerifyPhoneStepsProps {
    contacts: Array<Contact>;
}

export function VerifyPhoneSteps({ contacts }: VerifyPhoneStepsProps) {
    const { currentStep, next } = useSteps();

    return currentStep === 0 ? (
        <SendPhoneOtpStep onNext={next} contacts={contacts} />
    ) : currentStep === 1 ? (
        <VerifyPhoneStep contacts={contacts} />
    ) : null;
}
